import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import api from '../services/api';

export default function AgentsPage({ setPage }) {
  const [form, setForm] = useState({
    productId: '',
    storeId: '',
    replenishQuantity: ''
  });

  const [logs, setLogs] = useState({
    customer: [],
    store: [],
    warehouse: [],
    supplier: []
  });

  const [error, setError] = useState('');

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const callAgent = async (endpoint) => {
    setError('');
    try {
      const payload = {
        productId: Number(form.productId),
        storeId: form.storeId ? Number(form.storeId) : undefined,
        replenishQuantity: form.replenishQuantity ? Number(form.replenishQuantity) : undefined
      };
      const { data } = await api.post(`/agent/${endpoint}`, payload);
      setLogs(prev => ({
        ...prev,
        [endpoint]: [`[${endpoint.toUpperCase()}] ${data.logs.join(' | ')}`, ...prev[endpoint]]
      }));
    } catch (e) {
      setError(e.response?.data.error || 'Agent call failed');
    }
  };

  const renderLogs = (type) => logs[type]?.length > 0 && (
    <div className="mt-2 bg-light p-2 rounded">
      <strong>Logs:</strong>
      {logs[type].map((log, idx) => (
        <div key={idx} className="small">{log}</div>
      ))}
    </div>
  );

  return (
    <Container className="card-transparent p-4">
      <Header />
      <Navbar setPage={setPage} />
      <h2 className="mb-4">Agent Endpoints</h2>
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Customer Agent */}
      <Card className="mb-4 p-3" style={{ background: '#D9EAFD' }}>
        <h4>Customer Agent</h4>
        <p>Handles customer demand simulation and triggers related purchase activities.</p>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Product ID</Form.Label>
            <Form.Control name="productId" type="number" placeholder="Enter Product ID" value={form.productId} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Store ID</Form.Label>
            <Form.Control name="storeId" type="number" placeholder="Enter Store ID" value={form.storeId} onChange={handleChange} />
          </Form.Group>
          <Button variant="primary" onClick={() => callAgent('customer')}>Run Customer Agent</Button>
        </Form>
        {renderLogs('customer')}
      </Card>

      {/* Store Agent */}
      <Card className="mb-4 p-3" style={{ background: '#D9EAFD' }}>
        <h4>Store Agent</h4>
        <p>Monitors store stock levels and places restock requests to warehouses.</p>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Product ID</Form.Label>
            <Form.Control name="productId" type="number" placeholder="Enter Product ID" value={form.productId} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Store ID</Form.Label>
            <Form.Control name="storeId" type="number" placeholder="Enter Store ID" value={form.storeId} onChange={handleChange} />
          </Form.Group>
          <Button variant="primary" onClick={() => callAgent('store')}>Run Store Agent</Button>
        </Form>
        {renderLogs('store')}
      </Card>

      {/* Warehouse Agent */}
      <Card className="mb-4 p-3" style={{ background: '#D9EAFD' }}>
        <h4>Warehouse Agent</h4>
        <p>Manages warehouse inventory and triggers replenishment from suppliers.</p>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Product ID</Form.Label>
            <Form.Control name="productId" type="number" placeholder="Enter Product ID" value={form.productId} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Store ID</Form.Label>
            <Form.Control name="storeId" type="number" placeholder="Enter Store ID" value={form.storeId} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Replenish Quantity</Form.Label>
            <Form.Control name="replenishQuantity" type="number" placeholder="Enter Replenish Quantity" value={form.replenishQuantity} onChange={handleChange} />
          </Form.Group>
          <Button variant="primary" onClick={() => callAgent('warehouse')}>Run Warehouse Agent</Button>
        </Form>
        {renderLogs('warehouse')}
      </Card>

      {/* Supplier Agent */}
      <Card className="mb-4 p-3" style={{ background: '#D9EAFD' }}>
        <h4>Supplier Agent</h4>
        <p>Fulfills orders placed by warehouses and restocks them with required items.</p>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Product ID</Form.Label>
            <Form.Control name="productId" type="number" placeholder="Enter Product ID" value={form.productId} onChange={handleChange} />
          </Form.Group>
          <Button variant="primary" onClick={() => callAgent('supplier')}>Run Supplier Agent</Button>
        </Form>
        {renderLogs('supplier')}
      </Card>
    </Container>
  );
}
